var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { faArrowLeft, faEye, faPlay } from "@fortawesome/free-solid-svg-icons";
import { useEventBus } from "@vueuse/core";
import { invocationsFetcher } from "@/api/invocations";
import { useHistoryStore } from "@/stores/historyStore";
import { useUserStore } from "@/stores/userStore";
import { useWorkflowStore } from "@/stores/workflowStore";
const { emit } = useEventBus("grid-router-push");
/**
 * Request and return invocations for the given workflow (and current user) from server
 */
function getData(offset, limit, search, sort_by, sort_desc, extraProps) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function* () {
        const userStore = useUserStore();
        if (((_a = userStore.currentUser) === null || _a === void 0 ? void 0 : _a.isAnonymous) || !userStore.currentUser || !extraProps || !extraProps["workflow_id"]) {
            // TODO: maybe raise an error here?
            return [[], 0];
        }
        const workflowId = extraProps["workflow_id"];
        const { data, headers } = yield invocationsFetcher({
            limit,
            offset,
            sort_by: sort_by,
            sort_desc,
            user_id: userStore.currentUser.id,
            workflow_id: workflowId,
        });
        fetchHistories(data);
        const totalMatches = parseInt((_b = headers.get("total_matches")) !== null && _b !== void 0 ? _b : "0");
        return [data, totalMatches];
    });
}
/**
 * Fetch histories for the given workflow's invocations, if not already loaded,
 * so that they are cached and names are available for display in the grid
 */
function fetchHistories(invocations) {
    const historyStore = useHistoryStore();
    const historyIds = new Set();
    invocations.forEach((invocation) => {
        historyIds.add(invocation.history_id);
    });
    historyIds.forEach((history_id) => historyStore.getHistoryById(history_id) || historyStore.loadHistoryById(history_id));
}
/**
 * Actions are grid-wide operations
 */
const actions = [
    {
        title: "Invocations List",
        icon: faArrowLeft,
        handler: () => {
            emit("/workflows/invocations");
        },
    },
];
/**
 * Declare columns to be displayed
 */
const fields = [
    {
        key: "expand",
        title: null,
        type: "expand",
    },
    {
        key: "view",
        title: "View",
        type: "button",
        icon: faEye,
        handler: (data) => {
            emit(`/workflows/invocations/${data.id}`);
        },
        converter: () => "",
    },
    {
        key: "history_id",
        title: "History",
        type: "history",
    },
    {
        key: "create_time",
        title: "Invoked",
        type: "date",
    },
    {
        key: "state",
        title: "State",
        type: "helptext",
        converter: (data) => {
            const invocation = data;
            return `galaxy.invocations.states.${invocation.state}`;
        },
    },
    {
        key: "execute",
        title: "Run",
        type: "button",
        icon: faPlay,
        condition: (data) => {
            const invocation = data;
            const workflowStore = useWorkflowStore();
            const workflow = workflowStore.getStoredWorkflowByInstanceId(invocation.workflow_id);
            return !(workflow === null || workflow === void 0 ? void 0 : workflow.deleted);
        },
        handler: (data) => {
            const invocation = data;
            const workflowStore = useWorkflowStore();
            emit(`/workflows/run?id=${workflowStore.getStoredWorkflowIdByInstanceId(invocation.workflow_id)}`);
        },
        converter: () => "",
    },
];
/**
 * Grid configuration
 */
const gridConfig = {
    id: "invocations-workflow-grid",
    actions: actions,
    fields: fields,
    getData: getData,
    plural: "Workflow Invocations",
    sortBy: "create_time",
    sortDesc: true,
    sortKeys: ["create_time"],
    title: "Workflow Invocations For Workflow",
};
export default gridConfig;
